import React, { PropTypes } from 'react';
import cx from 'classnames';

const loaderClass = visible =>
  cx('ui inverted dimmer', {
    active: visible,
  });

const Loader = ({ text, visible = false }) => (
  <div className={loaderClass(visible)}>
    <div className="ui text loader">{text}</div>
  </div>
);

Loader.propTypes = {
  text: PropTypes.string.isRequired,
  visible: PropTypes.bool,
};

export default Loader;



// WEBPACK FOOTER //
// ./src/modules/common/components/Loader.js